import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspaceDeveloperApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useWorkspaceDeveloperDeliveriesQuery.ts
var r = (r = {}, i = !0) => t({
	queryKey: e.deliveries(r),
	queryFn: () => n.deliveries(r),
	enabled: i
});
//#endregion
export { r as useWorkspaceDeveloperDeliveriesQuery };
